<template>
  <div class="container-progress" id="container-progress">
    <canvas
      :id="canvasId"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></canvas>
  </div>
</template>

<script>
//   :currentLevel="风险较高"
//   :perfectLevel="风险一般"
//   :levels="['风险极低','风险较低','风险一般','风险较高','风险极高']"
//   :levelColors="['#0E7CE2', '#FF8352', '#E271DE', '#F8456B', '#00FFFF']"
//   :texts="['风险等级', '理想风险', '当前风险']"

export default {
  name: "compare-progress",
  props: {
    canvasId: {
      type: String,
      default: "canvas-progress",
    },
    currentLevel: {
      type: String,
      default: "",
    },
    perfectLevel: {
      type: String,
      default: "",
    },
    levels: {
      type: Array,
      default: function () {
        return ["极差", "很差", "较差", "一般", "较好", "很好", "非常好"];
      },
    },
    levelColors: {
      type: Array,
      default: function () {
        return [
          "#0E7CE2",
          "#FF8352",
          "#E271DE",
          "#F8456B",
          "#00FFFF",
          "#4AEAB0",
          "#FF8352",
        ];
      },
    },
    texts: {
      type: Array,
      default: function () {
        return ["健康值等级", "理想健康值", "当前健康值"];
      },
    },
  },
  data() {
    return {
      circleLoading: null,
      process: 0,
      width: 0,
      height: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      this.load();
    });
  },
  mounted() {
    console.log("mounted: 当前：理想", this.currentLevel, this.perfectLevel);
  },
  watch: {
    currentLevel(val) {
      console.log("currentLevel: ", val);
      this.load();
    },
  },
  methods: {
    load() {
      let containerProgress = document.getElementById("container-progress");
      let container = containerProgress.getBoundingClientRect();

      this.width = container.width;
      this.height = container.height;

      let canvas = document.getElementById(this.canvasId);
      // console.log(this.canvasId);
      let context = canvas.getContext("2d");

      let dpr = window.devicePixelRatio; // 假设dpr为2
      // console.log(dpr);
      // let dpr = 3; // 假设dpr为2
      // console.log(dpr);
      // 获取css的宽高
      // let { width: cssWidth, height: cssHeight } = canvas.getBoundingClientRect();
      // console.log(cssWidth,cssHeight);
      // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
      canvas.width = dpr * this.width;
      canvas.height = dpr * this.height;

      // /*绘制*/
      // let that = this;
      // this.circleLoading = setInterval(function () {
      //     that.drawCircle(context, canvas, dpr);
      // },20);

      this.drawCircle(context, canvas, dpr);
    },
    drawCircle(context, canvas, dpr) {
      // if (this.process >= this.value) {
      //     clearInterval(this.circleLoading);
      // }

      let center_x = canvas.width / 2;
      let center_y = canvas.height / 2;

      context.clearRect(0, 0, canvas.width, canvas.height);

      let numbers = this.numbers;
      let levels = this.levels;
      let levelColors = this.levelColors;

      context.save();

      let text = this.texts[0];
      let textFont = 14 * dpr;
      context.font = `${textFont}px 微软雅黑`;
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.fillStyle = "#666";

      let measureText = context.measureText(text);
      let textWidth = 120 * dpr;
      let bottomPadding = 45 * dpr;
      context.fillText(text, textWidth / 2, canvas.height - bottomPadding);

      let itemWidth = (canvas.width - textWidth) / levels.length;
      let font1 = 14 * dpr;

      for (let index = 0; index < levelColors.length; index++) {
        context.font = `${font1}px PingFangSC-Regular`;
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillStyle = "#666";
        let text = levels[index];
        context.fillText(
          text,
          textWidth + itemWidth / 2 + itemWidth * index,
          canvas.height - font1
        );

        // context.font = `${font2}px 微软雅黑`;
        // context.fillStyle = "gray";
        // let number = numbers[index];
        // context.fillText(number, textWidth + itemWidth*index, canvas.height - font1 - font2);
      }

      let font2 = 13 * dpr;
      let lineWidth = 10 * dpr;

      let canvasGradient1 = context.createLinearGradient(
        textWidth,
        canvas.height - font1 - font2 - lineWidth * 2,
        canvas.width - textWidth,
        canvas.height - font1 - font2 - lineWidth * 2
      );

      let spaced = 1.0 / levelColors.length;
      levelColors.forEach((item, index) => {
        canvasGradient1.addColorStop(spaced * index, item);
        // console.log(spaced*(index+1));
      });

      context.lineWidth = lineWidth;
      context.strokeStyle = canvasGradient1;
      context.lineCap = "round"; //线段端点的样式
      context.beginPath(); //开始创建路径
      context.moveTo(textWidth, canvas.height - font1 - font2 - lineWidth * 2);
      context.lineTo(
        canvas.width - textWidth,
        canvas.height - font1 - font2 - lineWidth * 2
      );
      context.stroke(); // 进行绘制外边框
      context.closePath(); //结束路径

      let text1 = this.texts[1];
      // let textFont1 = 15*dpr;
      // context.font = `${textFont1}px 微软雅黑`;
      // context.textBaseline = "middle";
      // context.textAlign = "center";
      // context.fillStyle = "#000";

      // let measureText1 = context.measureText(text1);
      // let textWidth1 = measureText1.width*2;
      context.fillText(text1, textWidth / 2, canvas.height - bottomPadding * 2);

      // let perfectIndex = levels.indexOf(this.perfectLevel);
      let perfectIndex = this.perfectLevel;

      if (perfectIndex > -1) {
        context.lineWidth = lineWidth;
        context.strokeStyle = canvasGradient1;
        context.beginPath(); //开始创建路径
        context.moveTo(textWidth, canvas.height - bottomPadding * 2);
        context.lineTo(
          (perfectIndex + 1) * itemWidth,
          canvas.height - bottomPadding * 2
        );
        context.stroke(); // 进行绘制外边框
        context.closePath(); //结束路径
      }
      console.log(5);
      let text2 = this.texts[2];

      // let measureText2 = context.measureText(text2);
      // let textWidth2 = measureText2.width*2;
      context.fillText(text2, textWidth / 2, canvas.height - bottomPadding * 3);

      let currentIndex = levels.indexOf(this.currentLevel);
      console.log(6);
      if (currentIndex > -1) {
        context.lineWidth = lineWidth;
        context.strokeStyle = canvasGradient1;
        context.beginPath(); //开始创建路径
        context.moveTo(textWidth, canvas.height - bottomPadding * 3);
        context.lineTo(
          (currentIndex + 1) * itemWidth,
          canvas.height - bottomPadding * 3
        );
        console.log(7);
        context.stroke(); // 进行绘制外边框
        context.closePath(); //结束路径
      }
      console.log(8);

      // let perfectIndex = 0;
      // for (let index = 0; index < numbers.length; index++) {
      //     const element = numbers[index];
      //     // console.log(element,this.perfectValue);
      //     if (element >= this.perfectValue) {
      //         perfectIndex = index;
      //         break;
      //     }
      // }
      // // console.log(perfectIndex);

      // let perfectWidth = textWidth;
      // if (perfectIndex > 0) {
      //     let space = itemWidth/(numbers[perfectIndex] - numbers[perfectIndex - 1]);
      //     perfectWidth = textWidth + itemWidth*(perfectIndex-1) + space*(this.perfectValue - numbers[perfectIndex - 1]);
      // }
      // // console.log(perfectWidth);

      // let lineWidth = 10*dpr;
      // context.lineWidth = lineWidth;
      // context.strokeStyle = levelColors[perfectIndex>0?perfectIndex-1:0];
      // context.beginPath(); //开始创建路径
      // context.moveTo(textWidth,canvas.height - bottomPadding*2);
      // context.lineTo(perfectWidth,canvas.height - bottomPadding*2);
      // context.stroke(); // 进行绘制外边框
      // context.closePath(); //结束路径

      // let text2 = this.texts[2];
      // let textFont2 = 15*dpr;
      // context.font = `${textFont2}px 微软雅黑`;
      // context.textBaseline = "middle";
      // context.textAlign = "center";
      // context.fillStyle = "#000";

      // let measureText2 = context.measureText(text2);
      // let textWidth2 = measureText2.width*2;
      // context.fillText(text2, textWidth2/2, canvas.height - bottomPadding*3);

      // let currentIndex = 0;
      // for (let index = 0; index < numbers.length; index++) {
      //     const element = numbers[index];
      //     // console.log(element,this.currentValue);
      //     if (element >= this.currentValue) {
      //         currentIndex = index;
      //         break;
      //     }
      // }
      // // console.log(currentIndex);

      // let currentWidth = textWidth;
      // if (currentIndex > 0) {
      //     let space = itemWidth/(numbers[currentIndex] - numbers[currentIndex - 1]);
      //     currentWidth = textWidth + itemWidth*(currentIndex-1) + space*(this.currentValue - numbers[currentIndex - 1]);
      // }
      // // console.log(currentWidth);

      // context.strokeStyle = levelColors[currentIndex>0?currentIndex-1:0];
      // context.beginPath(); //开始创建路径
      // context.moveTo(textWidth,canvas.height - bottomPadding*3);
      // context.lineTo(currentWidth,canvas.height - bottomPadding*3);
      // context.stroke(); // 进行绘制外边框
      // context.closePath(); //结束路径

      // context.restore();
    },
  },
};
</script>

<style scoped>
.container-progress {
  /* background-color: red; */
  box-sizing: border-box;
}
</style>
